import { Component, OnInit, Input, DoCheck } from '@angular/core';
import { IContentElementImage } from '../models';
import {BrowserModule, DomSanitizer, SafeResourceUrl} from '@angular/platform-browser'
@Component({
  selector: 'render-image',
  templateUrl: './render-image.component.html',
  styleUrls: ['./render-image.component.scss']
})
export class RenderImageComponent implements OnInit, DoCheck {

  @Input() element:IContentElementImage;

  urlRaw:string;
  url:SafeResourceUrl;
  warnedMissingAltForUrl:string;

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.updateUrl();
  }

  ngDoCheck() {
    this.updateUrl();
  }

  updateUrl(){
    const url = this.element?.url || this.element?.images?.default.image?.url;
    if (this.urlRaw !== url){
      this.urlRaw = url;
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlRaw);
    }
  }

  getImageUrl(){
    return this.url;
  }

  getAltText(){
    if (!this.element){
      return '';
    }
    if (this.element.altText !== undefined && this.element.altText !== null){
      return this.element.altText;
    }
    const nestedAlt = this.element.images?.default?.image?.altText;
    if (nestedAlt !== undefined && nestedAlt !== null){
      return nestedAlt;
    }
    if (this.warnedMissingAltForUrl !== this.urlRaw){
      this.warnedMissingAltForUrl = this.urlRaw;
      console.warn('Missing image alt text in ui-testrunner renderer.', this.element);
    }
    return 'Image';
  }

}
